import { render, staticRenderFns } from "./need-help-faq.vue?vue&type=template&id=21695e74"
import script from "./need-help-faq.vue?vue&type=script&lang=js"
export * from "./need-help-faq.vue?vue&type=script&lang=js"
import style0 from "./need-help-faq.vue?vue&type=style&index=0&id=21695e74&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports